module.exports = __webpack_public_path__ + "static/media/opera.1d6c62c7.jpg";